import { render, staticRenderFns } from "./ProductImageUpload.vue?vue&type=template&id=74bdd5de&scoped=true&"
import script from "./ProductImageUpload.vue?vue&type=script&lang=js&"
export * from "./ProductImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageUpload.vue?vue&type=style&index=0&id=74bdd5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bdd5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VImg,VProgressCircular})
